// src/app/App.js
import { Routes, Route, Navigate } from "react-router-dom";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";

import Home from "../pages/public/Home";
import BattleDetail from "../pages/public/BattleDetail";
import Classement from "../pages/public/Classement";
import PlayerSuggestions from "../pages/public/PlayerSuggestions";
import Faq from "../pages/public/Faq";
import Contact from "../pages/public/Contact";
import Forum from "../pages/forum/Forum";
import Authentification from "../pages/auth/Authentification";
import ProfilePage from "../pages/profile/Profile";
import Notifications from "../pages/profile/Notifications";
import PublicProfile from "../pages/profile/PublicProfile";
import PublicTeam from "../pages/profile/PublicTeam";
import ReportProfile from "../pages/profile/ReportProfile";
import ProtectedRoute from "../routes/ProtectedRoute";

import GameRoom from "../pages/game/GameRoom";  // ✅ AJOUT
import Cgu from "../pages/legal/Cgu";
import PolitiqueConfidentialite from "../pages/legal/PolitiqueConfidentialite";
import MentionsLegales from "../pages/legal/MentionsLegales";
import Cookies from "../pages/legal/Cookies";
import CookieBanner from "../components/ui/CookieBanner";
import ActiveGameFloat from "../components/ui/ActiveGameFloat";

export default function App() {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Header global */}
      <Header />

      {/* Contenu principal */}
      <main className="flex-grow">
        <Routes>
          {/* Accueil */}
          <Route path="/" element={<Home />} />
          <Route path="/classement" element={<Classement />} />
          <Route
            path="/suggestions-des-joueurs/"
            element={
              <ProtectedRoute>
                <PlayerSuggestions />
              </ProtectedRoute>
            }
          />
          <Route path="/forum" element={<Forum />} />
          <Route path="/battles/:battleId" element={<BattleDetail />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />

          {/* Authentification */}
          <Route path="/authentification/*" element={<Authentification />} />

          {/* Page profil (protégée) */}
          <Route
            path="/profile/*"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            }
          />
          <Route path="/premium/checkout" element={<Navigate to="/" replace />} />
          <Route
            path="/joueurs/:publicSlug"
            element={
              <ProtectedRoute>
                <PublicProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/joueur/:publicSlug"
            element={
              <ProtectedRoute>
                <PublicProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/joueur/u/:userId"
            element={
              <ProtectedRoute>
                <PublicProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/equipe/t/:teamId"
            element={
              <ProtectedRoute>
                <PublicTeam />
              </ProtectedRoute>
            }
          />
          <Route
            path="/signaler/joueur/:userId"
            element={
              <ProtectedRoute>
                <ReportProfile />
              </ProtectedRoute>
            }
          />

          {/* 🎮 PAGE DE JEU */}
          <Route path="/game-quiz/:slug" element={<GameRoom />} />

          {/* Pages légales */}
          <Route path="/cgu" element={<Cgu />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cookies" element={<Cookies />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>

      {/* Footer global */}
      <Footer />

      {/* Bandeau consentement cookies */}
      <CookieBanner />

      {/* Flottant partie en cours */}
      <ActiveGameFloat />
    </div>
  );
}
